export default __webpack_public_path__ + "static/media/user-circle.198cca8c.svg";